export default __webpack_public_path__ + "static/media/dhl-logo.d2af088f.png";